import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

const slides = [
  {
    img: "https://public.readdy.ai/ai/img_res/edited_dca043815ed393ffa75919d048c963a8_ca648be4.jpg",
    label: "TV Installation",
    labelEs: "Instalación de TV",
  },
  {
    img: "https://readdy.ai/api/search-image?query=cheerful%20Hispanic%20family%20mother%20father%20young%20children%20standing%20at%20front%20door%20of%20beautiful%20Florida%20suburban%20home%20warmly%20waving%20and%20smiling%20at%20professional%20cleaning%20crew%20man%20and%20woman%20in%20green%20uniforms%20arriving%20sunny%20bright%20day%20trust%20community%20gratitude%20welcoming%20friendly%20residential%20cleaning%20service&width=1920&height=1080&seq=hero_family_door_new2&orientation=landscape",
    label: "Happy Families",
    labelEs: "Familias Felices",
  },
  {
    img: "https://public.readdy.ai/ai/img_res/edited_9cbc64948761be9e689b859eee6e6e20_2f634a0f.jpg",
    label: "Move-In Cleaning",
    labelEs: "Limpieza de Mudanza",
  },
];

const HeroSection = () => {
  const { i18n } = useTranslation();
  const [current, setCurrent] = useState(0);
  const isEs = i18n.language === "es";

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4500);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Sliding Background */}
      {slides.map((slide, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-1000 ${i === current ? "opacity-100" : "opacity-0"}`}
        >
          <img
            src={slide.img}
            alt={slide.label}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/55 to-black/20"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

      {/* Content */}
      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 pt-28 pb-20">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-brand-green/20 border border-brand-green/50 text-green-300 px-4 py-1.5 rounded-full text-xs font-body mb-6 tracking-wide uppercase">
            <i className="ri-map-pin-2-fill text-brand-green"></i>
            {isEs ? "Negocio Familiar · Royal Palm Beach, FL" : "Family-Owned Business · Royal Palm Beach, FL"}
          </div>

          {/* Title */}
          <h1 className="font-heading font-black text-white leading-[1.1] mb-5">
            <span className="block text-5xl md:text-6xl lg:text-7xl">Adry &amp; Mich</span>
            <span className="block text-3xl md:text-4xl lg:text-5xl text-brand-green mt-1">Cleaning &amp; Handyman</span>
            <span className="block text-sm md:text-base font-medium text-white/60 mt-3 tracking-widest uppercase">
              {isEs
                ? "Limpieza · Reparaciones · Servicio en el que Puedes Confiar"
                : "Cleaning · Repairs · Reliable Service You Can Trust"}
            </span>
          </h1>

          {/* Subtitle */}
          <p className="font-body text-white/75 text-base md:text-lg leading-relaxed mb-8 max-w-lg">
            {isEs
              ? "Servicios profesionales de limpieza, cuidado de mascotas y reparaciones en Royal Palm Beach, FL y sus alrededores. Tratamos tu hogar como el nuestro — resultados impecables, siempre."
              : "Professional home cleaning, dog sitting & handyman services in Royal Palm Beach, FL & surrounding areas. We treat your home like our own — spotless results, every time."}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 mb-10">
            <a
              href="https://wa.me/15612626118"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-brand-green hover:bg-brand-green-dark text-white px-7 py-4 rounded-full font-heading font-bold text-sm transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-brand-green/30"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              {isEs ? "Cotización Gratis" : "Get a Free Quote"}
            </a>
            <Link
              to="/services"
              className="flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 text-white px-7 py-4 rounded-full font-heading font-semibold text-sm transition-all cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              {isEs ? "Ver Servicios" : "Explore Services"}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

        </div>
      </div>

      {/* Slide indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`transition-all cursor-pointer rounded-full ${i === current ? "w-8 h-2 bg-brand-green" : "w-2 h-2 bg-white/40 hover:bg-white/60"}`}
          />
        ))}
      </div>

      {/* Current slide label */}
      <div className="absolute bottom-8 right-6 md:right-10">
        <span className="font-body text-white/50 text-xs tracking-widest uppercase">
          {isEs ? slides[current].labelEs : slides[current].label}
        </span>
      </div>
    </section>
  );
};

export default HeroSection;
